import FootballStatsCategory from "../../../stats/football-stats-category";
import FootballState from "../../../state/football-state";
import StatsRule from "../../../../common/stats-rule";

export default class RushStats extends StatsRule {
    // eslint-disable-next-line no-unused-vars
    applicable(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        return (
            [FootballState.Run, FootballState.Rush].some(
                (state) => state === fragment.associatedState
            ) &&
            super.applicable(gameContext, ruleContext, eventConfiguration, {
                play,
                fragment
            })
        );
    }

    // eslint-disable-next-line no-unused-vars
    async apply(
        gameContext,
        ruleContext,
        eventConfiguration,
        { play, fragment }
    ) {
        const [player] = fragment.getPlayers();

        const yards_gained =
            (fragment.fieldPosition - gameContext.fieldPosition) *
            gameContext.getFieldDirectionMultiplier();

        return this.addStats({
            gameId: play.gameId,
            playId: play.id,
            period: gameContext.currentPeriod,
            teamId: player.teamId,
            playerId: player.id,
            driveId: gameContext.currentDriveId,
            fragmentId: fragment.id,
            category: FootballStatsCategory.RUSH,
            values: {
                attempted: 1,
                completed: 1,
                yards: yards_gained
            }
        });
    }
}
